var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-home-invest-button"},[_c('div',{staticClass:"plugin-home-invest-button__wrap"},[_c('home-invest-button')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }